import styled from '@xstyled/styled-components';
import React, { forwardRef } from 'react';
import { t } from 'ttag';
import { createPortal } from 'react-dom';
import { select } from '~/lib/select';
import { FeedbackButtonEds } from '~/ui/buttons';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { ThumbsPages, useThumbsStore } from './Store';

const Button = styled(FeedbackButtonEds)`
  position: fixed;
  top: 128px;
  right: 8px;
  font-size: 30px;
  z-index: hud;
  &:focus {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: md;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }
  @media ((max-width: 580px) and (max-height: 300px)) {
    top: 100px;
    right: 10px;
  }
  @media (max-height: 220px) {
    top: 88px;
    right: 10px;
  }
`;

const selector = (s: MediaPlayerStore) => select(s, 'pause');

export const OpenThumbsMenuButton = forwardRef<HTMLButtonElement>(
  function OpenThumbsMenuButton(_props, ref) {
    const { toggle, setPage } = useThumbsStore();
    const { pause } = useMediaPlayerStore(selector);

    return createPortal(
      <Button
        ref={ref}
        aria-label={t`Feedback`}
        onClick={() => {
          setPage(ThumbsPages.Root);
          pause();
          toggle();
        }}
      />,
      document.getElementById('root')!
    );
  }
);
